import Vue from 'vue';

export default Vue.extend({
  template: `<input type="hidden" :ref="'input'" v-model="value">`,
  data() {
    return {
      value: [],
      valueGetter: []
    };
  },
  methods: {
    isFilterActive() {
      return this.value && this.value.length > 0;
    },

    doesFilterPass(params) {
      return !this.value.some(el => el === this.valueGetter(params.node));
    },

    getModel() {
      return { value: this.value };
    },

    setModel(model) {
      if (model) {
        this.value = model.value;
      }
    },

    afterGuiAttached() {
      // this.$refs.input.focus();
    }
  },
  watch: {
    value(val, oldVal) {
      if (val !== oldVal) {
        this.params.filterChangedCallback();
      }
    }
  },
  created() {
    this.valueGetter = this.params.valueGetter;
  }
});
